import React, { useState } from "react"
import { generalStyles as gs } from "../../styles/styles"
import EmployesRH from "./EmployesRH"
import GroupesRH from "./GroupesRH"
import JoursFeriesV2 from "./JoursFeriesV2"

// Sous-navigation de l'onglet RH : « Employés » (liste + édition), « Groupes »
// (documentation des permissions) et « Jours fériés » (calendrier — déplacé
// depuis Dépannage, GE-16.5 ; le branchement J/N police est inchangé). Mêmes
// styles segmented que ConfigurationForm.
const SUBTABS = [
	{ key: "employes", label: "Employés" },
	{ key: "groupes", label: "Groupes" },
	{ key: "joursFeries", label: "Jours fériés" },
]

const RH = () => {
	const [sub, setSub] = useState("employes")

	return (
		<>
			<div style={gs.sectionTabs}>
				{SUBTABS.map((t) => (
					<button
						key={t.key}
						type="button"
						style={gs.sectionTab(sub === t.key)}
						onClick={() => setSub(t.key)}
					>
						{t.label}
					</button>
				))}
			</div>

			{sub === "employes" && <EmployesRH />}
			{sub === "groupes" && <GroupesRH />}
			{sub === "joursFeries" && <JoursFeriesV2 />}
		</>
	)
}

export default RH
